import React, { lazy, useEffect } from "react";
import { themeChange } from "theme-change";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import "./App.css";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";

// Importing pages
const Login = lazy(() => import("./pages/Login"));
// const Register = lazy(() => import("./pages/Register"));
const Layout = lazy(() => import("./containers/Layout"));
const Documentation = lazy(() => import("./pages/Documentation"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));

// Initializing different libraries
initializeApp();

// Check for login and initialize axios
const token = checkAuth();

function App() {
  useEffect(() => {
    // 👆 daisy UI themes initialization
    themeChange(false);
  }, []);

  return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/documentation" element={<Documentation />} />
          {/* Place new routes over this */}
          <Route path="/app/*" element={<Layout />} />
          <Route
            path="*"
            element={
              <Navigate to={token ? "/app" : "/login"} replace />
            }
          />

        </Routes>
      </Router>
  );
}

export default App;
